import { labels_hr } from "./labels_hr";
import { labels_en } from "./labels_en";
import LocalizationUtil from "./LocalizationUtil";

export const labels_localized = {
  hr_HR: labels_hr,
  en_US: labels_en
};

export const labels = LocalizationUtil.localize(labels_localized);
